import logo from "../assets/logo.jpg";

export default function Logo({ className = "", size = 40 }) {
  return (
    <img
      src={logo}
      alt="Zurita's Tree Services & Landscaping"
      style={{ height: size }}
      className={`w-auto object-contain select-none ${className}`}
      draggable={false}
    />
  );
}
